import { MultiAgencyService } from './../../shared/multi-agency/multi-agency.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { Observable } from 'rxjs/Observable';
import { User } from '../../auth/models/User';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { List } from 'immutable';

@Component({
  selector: 'pioneer-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public isEventSelected: boolean;

  userIsLoggedIn: Observable<boolean>;
  user: User;

  agencies = List<MultiAgency>();

  constructor(
    private authenticationStore: AuthenticationStore,
    private environment: EnvironmentConfiguration,
    private multiAgencyService: MultiAgencyService
  ) { }

  ngOnInit() {
    this.userIsLoggedIn = this.authenticationStore.isLoggedIn();
    this.authenticationStore.user.subscribe((user: User) => {
      this.user = user;
    });

    this.multiAgencyService.isEventSelected$.subscribe(event => {
      this.isEventSelected = event;
    });

    this.multiAgencyService.agencies.subscribe(agencies => {
      this.agencies = agencies;
    });
  }

  onLogout() {
    this.authenticationStore.logout();
  }

  get username() {
    return {
      username: this.user.username
    };
  }

  onClickPrivacy(event) {
    window.open(this.environment.policyUrl, '_blank');
  }

  getPortalUrl() {
    return this.environment.portalUrl;
  }

  onClickRedirect(event) {
    window.open(this.getPortalUrl(), '_self');
  }

  get defaultAgencyId(): Observable<string> {
    return this.multiAgencyService.defaultAgencyId;
  }

  get defaultAgencyName(): Observable<string> {
    return this.multiAgencyService.defaultAgencyName;
  }

  get isMultiAgency(): Observable<boolean> {
    return this.multiAgencyService.isMultiAgency();
  }

  get isSingleAgency(): Observable<boolean> {
    return this.multiAgencyService.isSingleAgency();
  }

  onClickAgency(agency: MultiAgency): void {
    if (this.multiAgencyService.oldAgencyId !== agency.agencyId) {
      this.authenticationStore.updateIataFromToken(agency.agencyId).subscribe(() => {
        this.multiAgencyService.setAgencySelectedUI(true);
        this.multiAgencyService.setDefaultAgency(agency);
      });
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/navigation/header/header.component.ts